export default __webpack_public_path__ + "static/media/dime_face.699274e3.png";